import { Table } from "containers/Table";
import { IColum } from "containers/Table/interfaces";
import { Button, Container, DivAcoes, Header, TextoHeader } from "./style";
import { formatarDinheiro } from "_utils/Money";
import {
  FaDollarSign,
  FaEye,
  FaMoneyCheck,
  FaPen,
  FaUniversity,
  FaUser,
} from "react-icons/fa";
import { utils, writeFileXLSX } from "xlsx";
import { HttpResponse } from "_services/api/HttpResponse";
import { HttpError } from "_services/api/HttpError";
import { IData } from "_services/api/interface/HttpResponse";
import { useEffect, useState } from "react";
import { toastErro } from "components/Toast";
import { converterDataBr, converterDataHoraBr } from "_utils/Data";
import { IListarPagamentoFornecedorAprovado } from "../../../../interface/IListarPagamentoFornecedorAprovado";
import { LoadingEstatisticaLote } from "../LoadingEstatisticaLote";
import { IEstatisticasLotePagamentoAprovado } from "../../../../interface/IEstatisticasLotePagamentoAprovado";
import { OpcoesExportar } from "../OpcoesExportar";
import { StatusPagamento } from "../StatusPagamento";
import { ModalDetalhesLotePagamento } from "../ModalDetalhesLotePagamento";
import { IDetalheLotePagamento } from "../../../../interface/IDetalheLotePagamento";
import { ModalDadosBancarios } from "../ModalDadosBancarios";
import { IDadosBancarios } from "../../../../interface/IDadosBancarios";
import { ModalConfirmarPagamento } from "../ModalConfirmarPagamento";
import { IConfirmarPagamento } from "../../../../interface/IConfirmarPagamento";
import usePermissoes from "hooks/usePermissoes";
import { ModalConfirmarCorrigirLotes } from "../ModalConfirmarCorrigirLotes";
import { ModalSucessoEnviarParaCorrecao } from "../ModalSucessoEnviarParaCorrecao";

interface IListarProps {
  dados: IListarPagamentoFornecedorAprovado[];
  handleLimitChange: (e: number) => void;
  handlePageChange: (e: number) => void;
  totalRows: number;
  setRowsSelected: (ids: number[]) => void;
  selectedRows: any[];
  loadingLista: boolean;
  linhasPorPagina: number;
  confirmarPagamento: (
    dados: IConfirmarPagamento,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  showModalDetalhesLotePagamento: boolean;
  handleCloseModalDetalhes: () => void;
  onClickVerDetalhes: (idLote: number) => void;
  buscarEstatisticasLotePagamento: (
    idLote: number,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  buscarEstatisticasPagamento: (
    idProcessoFinanceiroAprovar: number,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  onClickProcesso: (idProcesso: number) => void;
  relatorioDetalhado: (
    statusAprovacaoLote: "APROVADO" | "PENDENTE" | "REPROVADO",
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  dadosDetalhes: IDetalheLotePagamento[];
  buscarComprovantes: (
    idsLotes: number[],
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  numeroNfReciboEscolhido: string;
  onClickVerReciboNf: (idLote: number, numeroNfRecibo: string) => void;
  clearRows: boolean;
  enviarLotesParaCorrecao: (
    motivo: string,
  ) => Promise<HttpResponse<any, any> | HttpError<IData, any>>;
  aba: string;
}

export function ListarAprovados({
  dados,
  handleLimitChange,
  handlePageChange,
  totalRows,
  setRowsSelected,
  selectedRows,
  loadingLista,
  linhasPorPagina,
  confirmarPagamento,
  showModalDetalhesLotePagamento,
  handleCloseModalDetalhes,
  onClickVerDetalhes,
  buscarEstatisticasLotePagamento,
  buscarEstatisticasPagamento,
  onClickProcesso,
  relatorioDetalhado,
  dadosDetalhes,
  buscarComprovantes,
  numeroNfReciboEscolhido,
  onClickVerReciboNf,
  clearRows,
  enviarLotesParaCorrecao,
  aba,
}: IListarProps) {
  const dadosBancariosFornecedorDefault = {
    banco: "",
    agencia: "",
    conta: "",
    titularContaTransferencia: "",
    cpfCnpjTitularContaTransferencia: "",
    titularContaPix: "",
    chavePix: "",
    boleto: "",
  };
  const [estatisticasLotesPagamento, setEstatisticasLotesPagamento] = useState<
    IEstatisticasLotePagamentoAprovado[]
  >([]);
  const [showModalExportar, setShowModalExportar] = useState<boolean>(false);
  const [showModalDadosBancarios, setShowModalDadosBancarios] =
    useState<boolean>(false);
  const [dadosBancariosFornecedor, setDadosBancariosFornecedor] =
    useState<IDadosBancarios>(dadosBancariosFornecedorDefault);
  const [showModalConfirmarPagamento, setShowModalConfirmarPagamento] =
    useState<boolean>(false);
  const [showModalConfirmarCorrigirLotes, setShowModalConfirmarCorrigirLotes] =
    useState<boolean>(false);
  const [motivoCorrigir, setMotivoCorrigir] = useState<string | null>(null);
  const [
    showModalSucessoEnviarParaCorrigir,
    setShowModalSucessoEnviarParaCorrigir,
  ] = useState<boolean>(false);

  useEffect(() => {
    if (aba !== "aprovado") return;

    const estatisticasIniciais = dados.map((item) => ({
      idLote: item.id,
      qtdProcessos: null,
      totalPagarFornecedor: null,
    }));
    setEstatisticasLotesPagamento(estatisticasIniciais);

    dados.forEach((item) => {
      carregarEstatisticasLote(item.id);
    });
  }, [dados]);

  const carregarEstatisticasLote = async (idLote: number) => {
    const { hasErro, data } = await buscarEstatisticasLotePagamento(idLote);

    setEstatisticasLotesPagamento((prev) =>
      prev.map((item) => {
        if (item.idLote != idLote) {
          return item;
        }

        return {
          idLote: idLote,
          qtdProcessos: hasErro ? 0 : data.qtdProcessos,
          totalPagarFornecedor: hasErro ? 0 : data.totalPagarFornecedor,
          custoProcesso: hasErro ? 0 : data.custoProcesso,
          servicoReceber: hasErro ? 0 : data.servicoReceber,
        };
      }),
    );
  };

  const columns: IColum<IListarPagamentoFornecedorAprovado>[] = [
    {
      name: "Nº Recibo / NF",
      selector: ({
        numeroNfRecibo,
        id,
      }: IListarPagamentoFornecedorAprovado) => (
        <div
          className="link-primary"
          title="NF/Recibo"
          style={{ cursor: "pointer" }}
          onClick={() => {
            onClickVerReciboNf(id, numeroNfRecibo);
          }}
        >
          {numeroNfRecibo}
        </div>
      ),
      width: "150px",
    },
    {
      name: "ID lote",
      selector: ({ id }: IListarPagamentoFornecedorAprovado) => id,
      width: "90px",
    },
    {
      name: "Fornecedor",
      selector: ({ nomeFornecedor }: IListarPagamentoFornecedorAprovado) =>
        nomeFornecedor ?? "-",
      width: "150px",
    },
    {
      name: <span>Usuário lançamento</span>,
      selector: ({
        responsavelLancamento,
      }: IListarPagamentoFornecedorAprovado) => responsavelLancamento ?? "-",
    },
    {
      name: "Processos",
      selector: ({ id }: IListarPagamentoFornecedorAprovado) => {
        return (
          <LoadingEstatisticaLote
            id={id}
            estatisticasLotesPagamento={estatisticasLotesPagamento}
            item={"qtdProcessos"}
          />
        );
      },
    },
    {
      name: <span>Total a pagar</span>,
      selector: ({ valorNfRecibo }: IListarPagamentoFornecedorAprovado) =>
        valorNfRecibo ? formatarDinheiro(Number(valorNfRecibo)) : "-",
    },
    {
      name: <span>Data de validação</span>,
      selector: ({ dataValidacao }: IListarPagamentoFornecedorAprovado) =>
        dataValidacao ? converterDataHoraBr(dataValidacao) : "-",
      width: "150px",
    },
    {
      name: "Pagamento",
      selector: ({ dataPagamento }: IListarPagamentoFornecedorAprovado) => (
        <StatusPagamento status={dataPagamento ? "Pago" : "Pendente"} />
      ),
    },
    {
      name: <span>Data do pagamento</span>,
      selector: ({ dataPagamento }: IListarPagamentoFornecedorAprovado) =>
        dataPagamento ? converterDataBr(dataPagamento) : "-",
    },
    {
      name: "Ações",
      selector: ({
        id,
        banco,
        agencia,
        conta,
        titularContaTransferencia,
        cpfCnpjTitularContaTransferencia,
        titularContaPix,
        chavePix,
        dataPagamento,
        boleto,
        nomeFornecedor,
        numeroNfRecibo,
        valorNfRecibo,
        cpfCnpjFornecedor,
      }: IListarPagamentoFornecedorAprovado) => (
        <span>
          <FaEye
            title="Visualizar lote"
            onClick={() => onClickVerDetalhes(id)}
            style={{ cursor: "pointer", marginRight: 12, fontSize: 15 }}
          />
          <FaUniversity
            title="Dados bancários fornecedor"
            onClick={() => {
              setDadosBancariosFornecedor({
                banco,
                agencia,
                conta,
                titularContaTransferencia,
                cpfCnpjTitularContaTransferencia,
                titularContaPix,
                chavePix,
                boleto,
                nomeFornecedor,
                numeroNfRecibo,
                totalPagar: valorNfRecibo,
                cnpjFornecedor: cpfCnpjFornecedor,
              });
              setShowModalDadosBancarios(true);
            }}
            style={{ cursor: "pointer", marginRight: 12, fontSize: 15 }}
          />
          <FaMoneyCheck
            title="Comprovante de pagamento"
            onClick={dataPagamento ? () => buscarComprovantes([id]) : () => {}}
            style={
              dataPagamento
                ? { cursor: "pointer", fontSize: 15 }
                : { color: "#b3b3b3" }
            }
          />
        </span>
      ),
      width: "90px",
    },
  ];

  const abrirModalExportar = () => {
    setShowModalExportar(!showModalExportar);
  };

  const onClickComprovantes = async () => {
    setShowModalExportar(false);

    const { data, hasErro } = await buscarComprovantes(
      selectedRows.map((row) => row.id),
    );

    if (hasErro) {
      toastErro(data?.message ?? "Não foi possível baixar os comprovantes");
      return;
    }
  };

  const onClickDetalhado = async () => {
    setShowModalExportar(false);

    const { hasErro, data } = await relatorioDetalhado("APROVADO");

    if (hasErro) {
      toastErro(
        data?.message ?? "Não foi possível gerar o relatório detalhado",
      );
      return;
    }

    const dadosPlanilha = data.map((item: any) => {
      return {
        "ID PROCESSO": item?.idProcesso ? item?.idProcesso : "-",
        PLACA: item?.placa ? item?.placa : "-",
        RENAVAM: item?.renavam ? item?.renavam : "-",
        SERVIÇO: item?.servico ? item?.servico : "-",
        EMPRESA: item?.nomeEmpresa ? item?.nomeEmpresa : "-",
        "CNPJ/CPF FORNECEDOR": item?.cpfCnpjFornecedor
          ? item?.cpfCnpjFornecedor
          : "-",
        "NOME FORNECEDOR": item?.nomeFornecedor ? item?.nomeFornecedor : "-",
        "VALOR DO PAGAMENTO": item?.valorPagamento
          ? Number(item.valorPagamento)
          : 0,
        "CHAVE PIX": item?.chavePix ? item?.chavePix : "-",
        "TITULAR DA CONTA PIX": item?.titularPix ? item?.titularPix : "-",
        BANCO: item?.banco ? item?.banco : "-",
        AGÊNCIA: item?.agencia ? item?.agencia : "-",
        "CONTA CORRENTE": item?.contaCorrente ? item?.contaCorrente : "-",
        "CNPJ/CPF TITULAR CONTA CORRENTE": item?.cpfCnpjTitularContaCorrente
          ? item?.cpfCnpjTitularContaCorrente
          : "-",
        "TITULAR CONTA CORRENTE": item?.titularContaCorrente
          ? item?.titularContaCorrente
          : "-",
        "STATUS PAGAMENTO": item?.dataHoraPagamento ? "Pago" : "Pendente",
        "DATA/HORA INCLUSÃO": item?.dataInclusao
          ? converterDataHoraBr(item?.dataInclusao)
          : "-",
        "DATA/HORA VALIDAÇÃO": item?.dataHoraValidacao
          ? converterDataHoraBr(item?.dataHoraValidacao)
          : "-",
        "DATA/HORA PAGAMENTO": item?.dataHoraPagamento
          ? converterDataHoraBr(item?.dataHoraPagamento)
          : "-",
        "RESPONSÁVEL VALIDAÇÃO": item?.responsavelValidacao
          ? item?.responsavelValidacao
          : "-",
        "RESPONSÁVEL PAGAMENTO": item?.responsavelPagamento
          ? item?.responsavelPagamento
          : "-",
      };
    });

    const planilha = utils.json_to_sheet(dadosPlanilha);

    const colunaValor = 7;
    const range = utils.decode_range(planilha["!ref"] ?? "A1");
    for (let row = range.s.r + 1; row <= range.e.r; row++) {
      const cellRef = utils.encode_cell({ r: row, c: colunaValor });
      if (planilha[cellRef]) {
        planilha[cellRef].z = '"R$ "#,##0.00';
      }
    }

    planilha["!cols"] = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    const workBook = utils.book_new();
    utils.book_append_sheet(workBook, planilha, "Detalhes");

    const hoje = new Date();
    const dia = String(hoje.getDate()).padStart(2, "0");
    const mes = String(hoje.getMonth() + 1).padStart(2, "0");
    const ano = hoje.getFullYear();
    const nomeArquivo = `PGTO_FORNECEDOR_${dia}-${mes}-${ano}_DETALHADO.xlsx`;
    writeFileXLSX(workBook, nomeArquivo);
  };

  const onSubmitConfirmarPagamento = async (dados: IConfirmarPagamento) => {
    setShowModalConfirmarPagamento(false);

    const { hasErro, data } = await confirmarPagamento(dados);

    if (hasErro) {
      toastErro(data?.message ?? "Não foi possível confirmar pagamento");
      return;
    }
  };

  const onSubmitConfirmarCorrigirLotes = async () => {
    if (!motivoCorrigir) {
      toastErro("O motivo para correção é obrigatório");
      return;
    }

    const { hasErro, data } = await enviarLotesParaCorrecao(motivoCorrigir);

    if (hasErro) {
      toastErro(data?.message ?? "Não foi possível enviar lotes para correção");
      return;
    }

    setShowModalConfirmarCorrigirLotes(false);
    setShowModalSucessoEnviarParaCorrigir(true);
  };

  const { listaPermissoes } = usePermissoes();
  const [showBtnConfirmar, setShowBtnConfirmar] = useState<boolean>(false);

  useEffect(() => {
    if (!listaPermissoes || !Array.isArray(listaPermissoes)) {
      return;
    }

    if (
      listaPermissoes.some(
        (item) => item.nome_funcionalidade === "confirmar_pagamento_fornecedor",
      )
    ) {
      setShowBtnConfirmar(true);
    }
  }, [listaPermissoes]);

  return (
    <Container>
      <Header>
        <TextoHeader>Lotes aprovados para pagamento</TextoHeader>
        <DivAcoes>
          <Button
            outline
            variante="primary"
            onClick={abrirModalExportar}
            disabled={!selectedRows.length}
          >
            <FaUser /> Exportar
          </Button>
          {showBtnConfirmar && (
            <>
              <Button
                outline
                variante="primary"
                disabled={
                  !selectedRows.length ||
                  !!selectedRows.some((row) => {
                    return row.dataPagamento;
                  })
                }
                onClick={() => {
                  setShowModalConfirmarCorrigirLotes(true);
                }}
                style={{ width: "185px" }}
              >
                <FaPen /> Solicitar correção
              </Button>
              <Button
                variante="primary"
                disabled={
                  !selectedRows.length ||
                  !!selectedRows.some((row) => {
                    return row.dataPagamento;
                  })
                }
                onClick={() => {
                  setShowModalConfirmarPagamento(true);
                }}
                style={{ width: "185px" }}
              >
                <FaDollarSign /> Confirmar pagamento
              </Button>
            </>
          )}
          <OpcoesExportar
            aberto={showModalExportar}
            onClickComprovantes={onClickComprovantes}
            onClickDetalhado={onClickDetalhado}
          />
        </DivAcoes>
      </Header>
      <hr />
      <Table
        keyField="id"
        totalRows={totalRows}
        pagination={true}
        columns={columns}
        data={dados}
        paginationRowsPerPageOptions={[30, 50, 100, 300]}
        loading={loadingLista}
        onChangeRowsPerPage={handleLimitChange}
        onChangePage={handlePageChange}
        noSubHeader
        possuiTooltip={false}
        selectableRows
        setRowsSelected={setRowsSelected}
        rowsPerPage={linhasPorPagina}
        headerFixo
        clearSelectedRows={clearRows}
      />
      <ModalDetalhesLotePagamento
        show={showModalDetalhesLotePagamento}
        dados={dadosDetalhes}
        handleClose={handleCloseModalDetalhes}
        buscarEstatisticasPagamento={buscarEstatisticasPagamento}
        numeroNfRecibo={numeroNfReciboEscolhido}
        onClickProcesso={onClickProcesso}
      />
      <ModalDadosBancarios
        show={showModalDadosBancarios}
        handleClose={() => {
          setShowModalDadosBancarios(false);
          setDadosBancariosFornecedor(dadosBancariosFornecedorDefault);
        }}
        dados={dadosBancariosFornecedor}
      />
      <ModalConfirmarPagamento
        show={showModalConfirmarPagamento}
        handleClose={() => {
          setShowModalConfirmarPagamento(false);
        }}
        onSubmit={onSubmitConfirmarPagamento}
      />
      <ModalConfirmarCorrigirLotes
        show={showModalConfirmarCorrigirLotes}
        handleClose={() => setShowModalConfirmarCorrigirLotes(false)}
        onSubmit={onSubmitConfirmarCorrigirLotes}
        motivoCorrigir={motivoCorrigir}
        setMotivoCorrigir={setMotivoCorrigir}
      />
      <ModalSucessoEnviarParaCorrecao
        show={showModalSucessoEnviarParaCorrigir}
        handleClose={() => setShowModalSucessoEnviarParaCorrigir(false)}
      />
    </Container>
  );
}
